import { MessageProvider } from '../../services/resources/MessageProvider'

export interface MessageProps {
  id: string
  args?: string[]
}

export function Message(props: MessageProps) {
  const messageContent = MessageProvider.provide(props.id, ...props.args ?? [])
  return <>{messageContent}</>
}
